// Una fila de la lista de choferes: estado de la señal, teléfono, avisar al
// chofer y ver su recorrido. Tocarla la elige (centra el mapa y abre la ficha).
import React from "react";
import { Chofer, colorDe, conAtraso, atrasoMin, FUENTE, haceCuanto, horaCorta, llevaTurbo, MODO, nombreChofer, sinSenal, soloDigitos, TURBO } from "../../lib/liveDrivers";
import { badge, filaStyle, filaTituloStyle, linkBtnStyle, punto, smallMutedStyle } from "./styles";

type Props = {
  chofer: Chofer;
  elegido: boolean;
  aviso: { texto: string; ok: boolean } | null;
  avisando: boolean;
  tieneParadas: boolean;
  // Tildado para verlo en el mapa con el filtro «Elegidos».
  marcado: boolean;
  onMarcar: () => void;
  onElegir: () => void;
  onAvisar: () => void;
  onVerRecorrido: () => void;
};

export default function DriverRow({ chofer: c, elegido, aviso, avisando, tieneParadas, marcado, onMarcar, onElegir, onAvisar, onVerRecorrido }: Props) {
  const mudo = sinSenal(c);
  return (
    <div data-fila={`drivers:${c.driver_id}`} style={{ ...filaStyle, background: elegido ? "rgba(255,255,255,0.06)" : "transparent" }} onClick={onElegir}>
      <i style={punto(colorDe(c))} />
      <div>
        {/* Botón para llegar con el teclado; el clic sube a la fila. */}
        <button type="button" style={filaTituloStyle} aria-current={elegido ? "true" : undefined}>{nombreChofer(c)} <span style={{ ...smallMutedStyle, fontWeight: 400 }}>{c.username}{c.vehiculo ? ` · ${c.vehiculo}` : ""}</span>
          {llevaTurbo(c) ? <span style={{ ...badge(TURBO), marginLeft: "8px", background: "rgba(240,136,62,0.12)", whiteSpace: "nowrap" }}>Turbo #{c.turbo_route_id}{c.turbo_deadline_at ? ` · ${horaCorta(c.turbo_deadline_at)}` : ""}</span> : null}
          {c.turbo_enabled ? <span style={{ ...badge("var(--text-secondary)"), marginLeft: "8px", fontWeight: 500 }} title="Puede recibir ofertas de Turbo">habilitado</span> : null}
        </button>
        <div style={smallMutedStyle}>
          {haceCuanto(c.recorded_at)} · {FUENTE[c.source] ?? c.source}
          {conAtraso(c) ? <span style={{ color: "var(--warning, #d29922)" }}> · subió con {Math.round(atrasoMin(c))} min de atraso</span> : ""}
          {c.battery_level != null ? ` · batería ${Math.round(c.battery_level * 100)}%` : ""}
          {c.accuracy_m != null ? ` · ±${Math.round(c.accuracy_m)} m` : ""}
        </div>
        {c.tracking_mode && c.tracking_mode !== "background" ? (
          <div style={{ ...smallMutedStyle, color: "var(--warning, #d29922)" }}>{MODO[c.tracking_mode] ?? c.tracking_mode}{c.tracking_error ? ` · ${c.tracking_error}` : ""}</div>
        ) : null}
        <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap", marginTop: "4px" }} onClick={(e) => e.stopPropagation()}>
          {c.phone ? (
            <>
              <a href={`tel:${soloDigitos(c.phone)}`} style={{ ...smallMutedStyle, color: "var(--primary, #4f8cff)" }}>{c.phone}</a>
              <a href={`https://wa.me/${soloDigitos(c.phone)}`} target="_blank" rel="noreferrer" style={{ ...smallMutedStyle, color: "var(--primary, #4f8cff)" }}>WhatsApp</a>
            </>
          ) : <span style={smallMutedStyle}>sin teléfono cargado</span>}
          <button type="button" style={linkBtnStyle} disabled={avisando} onClick={onAvisar}>
            {avisando ? "avisando…" : "avisar al chofer"}
          </button>
          {tieneParadas ? <button type="button" style={linkBtnStyle} onClick={onVerRecorrido}>ver su recorrido</button> : null}
        </div>
        {aviso ? <div style={{ ...smallMutedStyle, color: aviso.ok ? "var(--success)" : "var(--warning, #d29922)" }}>{aviso.texto}</div> : null}
      </div>
      <span style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "6px" }}>
        <label title="Elegirlo para verlo en el mapa con el filtro «Elegidos»" style={{ display: "inline-flex", alignItems: "center", gap: "4px", cursor: "pointer", ...smallMutedStyle }} onClick={(e) => e.stopPropagation()}>
          <input type="checkbox" aria-label={`Elegir a ${nombreChofer(c)}`} checked={marcado} onChange={onMarcar} style={{ margin: 0 }} /> elegir
        </label>
        <span style={badge(mudo ? "var(--danger)" : conAtraso(c) ? "var(--warning, #d29922)" : "var(--success)")}>{mudo ? "sin señal" : conAtraso(c) ? "con atraso" : "ok"}</span>
      </span>
    </div>
  );
}
